module.exports = __webpack_public_path__ + "img/05.3a04d194.jpg";